module.exports = __webpack_public_path__ + "img/wsczzhjkyypt12.b261a037.png";